//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";

//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create or Update Lesson Plan ----------------
export const createOrUpdateLessonPlanSuccess = (returnedPayload) => ({
  type: ActionTypes.lesson_plan.createOrUpdateLessonPlanSuccess,
  payload: returnedPayload,
});

//  -- Delete Lesson Plan ----------------
export const deleteLessonPlanSuccess = (returnedPayload) => ({
  type: ActionTypes.lesson_plan.deleteLessonPlanSuccess,
  payload: returnedPayload,
});

//  -- List Lesson Plan by Book ----------------
export const listLessonPlanByBookSuccess = (returnedPayload) => ({
  type: ActionTypes.lesson_plan.listLessonPlanByBookSuccess,
  payload: returnedPayload,
});

//  -- List Lesson Plan by Book and User ----------------
export const listLessonPlanByBookAndUserSuccess = (returnedPayload) => ({
  type: ActionTypes.lesson_plan.listLessonPlanByBookAndUserSuccess,
  payload: returnedPayload,
});
